import CompanyWorkersView from "./CompanyWorkersView";

export default CompanyWorkersView;
